export default __webpack_public_path__ + "static/media/code.9c9d0e6e.svg";